<template>
    <ListeCategorieClient/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import ListeCategorieClient from "@/components/GesCom/CategorieClient/ListeCategorieClient.vue";

    export default defineComponent({
      name: "ListeCategorieClientPage",
      components: {
        ListeCategorieClient,
      },
    });
  </script>